import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { closeSwapRfs } from '@/store/swap/api/requestSwapRfs.ts';

export type CancelSwapRfsBody = {
  // useful to have a fixedCacheKey to remove the mutation result from the cache
  tileId: string;
  rfsId: string;
};

export type CancelSwapRfsResponse = {};

export const cancelSwapRfs = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<CancelSwapRfsResponse, CancelSwapRfsBody>({
    query: (body) => ({
      url: '/fxSwap/rfs/cancel',
      method: 'POST',
      body: {
        rfsId: body.rfsId,
      },
    }),

    onQueryStarted({ tileId, rfsId }, { dispatch }): Promise<void> | void {
      // stop the RFS stream (signalR listeners, timeouts, etc)
      closeSwapRfs(tileId, rfsId, dispatch);
    },

    // async onCacheEntryAdded(request, { cacheDataLoaded, cacheEntryRemoved, dispatch }) {
    //   // wait for the initial query to resolve before proceeding
    //   await cacheDataLoaded;
    //
    //   dispatch(rfsApi.internalActions.removeMutationResult({ fixedCacheKey: `rfs-request-${request.tileId}` }));
    //
    //   // const handleReceiveQuoteReply = buildHandleReceiveQuoteReply(request.rfsId, dispatch);
    //   // const handleReceiveQuoteAbort = buildHandleReceiveQuoteAbort(request.rfsId, dispatch);
    //   //
    //   // signalrConnection.on('ReceiveQuoteReply', handleReceiveQuoteReply);
    //   // signalrConnection.on('ReceiveQuoteAbort', handleReceiveQuoteAbort);
    //   // // TODO: ReceiveQuoteSolving ?
    //   // // TODO: ReceiveQuoteWithdraw ?
    //
    //   await cacheEntryRemoved; // TODO: remove automatic cache removed after 1 hour
    //   // dispatch(multipassApi.internalActions.removeMutationResult({ fixedCacheKey: rfsId  }));
    //
    //   // signalrConnection.off('ReceiveQuoteReply', handleReceiveQuoteReply);
    //   // signalrConnection.off('ReceiveQuoteAbort', handleReceiveQuoteAbort);
    // },
  });
};
